<template>
    <el-dialog
        :title="editId ? '编辑考勤组' : '新增考勤组'"
        :visible.sync="groupTplDialogVisible"
        width="560px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        class="custom-form-dialog custom-attendance-dialog"
    >
        <div v-loading="groupTplLoading">
            <el-form
                :model="attendanceForm"
                :rules="attendanceFormRules"
                label-position="top"
                ref="attendanceForm"
                size="small"
            >
                <el-form-item label="考勤组名称" prop="attendance_group_name">
                    <el-input
                        maxlength="20"
                        placeholder="请输入考勤组名称"
                        v-model="attendanceForm.attendance_group_name"
                    ></el-input>
                </el-form-item>
                <el-form-item label="考勤人员" prop="use_user">
                    <el-select
                        :popper-append-to-body="false"
                        @clear="handleClickClearPromoter()"
                        @focus="handleClickPromoter()"
                        @remove-tag="handleClickRemovePromoter($event)"
                        clearable
                        collapse-tags
                        key="selectPromoter"
                        multiple
                        placeholder="请选择考勤人员"
                        popper-class="promoterPopperClass"
                        ref="selectPromoter"
                        v-model.trim="attendanceForm.use_user_ids"
                    >
                        <el-option
                            v-for="item in attendanceForm.use_user"
                            :value="item.relate_type_id"
                            :label="item.relate_name"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <div class="groupSetUp">
                        <div class="groupSetUpTop">
                            <span>工作日设置</span>
                            <el-button @click="handleClickBatchChange()" size="small" type="text"
                                >批量更改班次</el-button
                            >
                        </div>
                        <div class="groupSetUpBottom">
                            <el-table
                                :data="attendanceForm.attendance_rule"
                                @selection-change="handleSelectionChange"
                                ref="multipleTable"
                                border
                                :header-cell-style="{ backgroundColor: '#EDF0F4', borderColor: 'rgba(0, 0, 0, 0.04)' }"
                            >
                                <el-table-column align="center" type="selection" width="55"></el-table-column>
                                <el-table-column
                                    label="工作日"
                                    prop="title"
                                    show-overflow-tooltip
                                    width="90"
                                ></el-table-column>
                                <el-table-column label="班次时间段" min-width="150" prop="name" show-overflow-tooltip>
                                    <template slot-scope="{ row }">
                                        <span v-if="row.data && row.data.day_type == 'reset'">休息日</span>
                                        <span v-else>
                                            <span v-if="row.data && row.data.work_time">
                                                <span v-if="row.data && row.data.work_time.start_time">{{
                                                    row.data.work_time.start_time
                                                }}</span>
                                                ~
                                                <span v-if="row.data && row.data.work_time.end_time">{{
                                                    row.data.work_time.end_time
                                                }}</span>
                                            </span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    label="操作"
                                    prop="title"
                                    show-overflow-tooltip
                                    width="80"
                                >
                                    <template slot-scope="scope">
                                        <el-button
                                            @click="handleClickEdit(scope.row, scope.$index)"
                                            size="small"
                                            type="text"
                                            >更改班次
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div class="legal">
                        <div>法定节假日自动排休</div>
                        <el-switch
                            :active-value="1"
                            :inactive-value="2"
                            v-model="attendanceForm.is_use_public_holiday"
                        ></el-switch>
                    </div>
                </el-form-item>
            </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button size="small" type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled"
                >保存</el-button
            >
        </span>
        <AttendanceGroupChange
            :groupChangeDialogVisible.sync="groupChangeDialogVisible"
            :groupChangeDialogTitle="groupChangeDialogTitle"
            :attendanceData="attendanceData"
            @callbackChangeSuccess="groupChangeSuccess"
            v-if="groupChangeDialogVisible"
        />
        <userDepartmentSelection
            :userDepartmentVisible.sync="userDepartmentVisible"
            v-if="userDepartmentVisible"
            :userDepartmentSelected="attendanceForm.use_user"
            :userDepartmentTitle="'考勤人员'"
            :type="'userDepartment'"
            :isAllStaff="true"
            :disabledData="disabledData"
            :checkStrictly="true"
            @success="userDepartmentSuccess"
        />
    </el-dialog>
</template>

<script>
import { AddAttendanceGroup, UpdateAttendanceGroup, GetAttendanceGroupUsers, GetAttendanceGroupDetail,GetAttendanceGroupWithUser } from "@/api";
import AttendanceGroupChange from "./attendance_group_change.vue";
import userDepartmentSelection from "@/components/pComponents/userDepartmentSelection.vue";
export default {
    name: "AttendanceGroupTpl",
    props: {
        groupTplDialogVisible: {
            type: Boolean,
            default: false,
        },
        editId: "",
    },
    components: { AttendanceGroupChange, userDepartmentSelection },
    data() {
        return {
            groupTplLoading: false,
            attendanceForm: {
                attendance_group_name: "",
                use_user: [],
                use_user_ids: [],
                attendance_rule: [
                    {
                        week: 1,
                        title: "周一",
                        data: {
                            day_type: "work", //reset
                            work_time: {
                                start_time: "09:00",
                                start_time_type: 1,
                                end_time: "18:00",
                                end_time_type: 1,
                            },
                            rest_time: [
                                {
                                    start_time: "12:00",
                                    start_time_type: 1,
                                    end_time: "13:00",
                                    end_time_type: 1,
                                },
                            ],
                            is_set_rset: 1,
                            work_per_day: 1,
                            work_hour: 8,
                        },
                    },
                    {
                        week: 2,
                        title: "周二",
                        data: {
                            day_type: "work", //reset
                            work_time: {
                                start_time: "09:00",
                                start_time_type: 1,
                                end_time: "18:00",
                                end_time_type: 1,
                            },
                            rest_time: [
                                {
                                    start_time: "12:00",
                                    start_time_type: 1,
                                    end_time: "13:00",
                                    end_time_type: 1,
                                },
                            ],
                            is_set_rset: 1,
                            work_per_day: 1,
                            work_hour: 8,
                        },
                    },
                    {
                        week: 3,
                        title: "周三",
                        data: {
                            day_type: "work", //reset
                            work_time: {
                                start_time: "09:00",
                                start_time_type: 1,
                                end_time: "18:00",
                                end_time_type: 1,
                            },
                            rest_time: [
                                {
                                    start_time: "12:00",
                                    start_time_type: 1,
                                    end_time: "13:00",
                                    end_time_type: 1,
                                },
                            ],
                            is_set_rset: 1,
                            work_per_day: 1,
                            work_hour: 8,
                        },
                    },
                    {
                        week: 4,
                        title: "周四",
                        data: {
                            day_type: "work", //reset
                            work_time: {
                                start_time: "09:00",
                                start_time_type: 1,
                                end_time: "18:00",
                                end_time_type: 1,
                            },
                            rest_time: [
                                {
                                    start_time: "12:00",
                                    start_time_type: 1,
                                    end_time: "13:00",
                                    end_time_type: 1,
                                },
                            ],
                            is_set_rset: 1,
                            work_per_day: 1,
                            work_hour: 8,
                        },
                    },
                    {
                        week: 5,
                        title: "周五",
                        data: {
                            day_type: "work", //reset
                            work_time: {
                                start_time: "09:00",
                                start_time_type: 1,
                                end_time: "18:00",
                                end_time_type: 1,
                            },
                            rest_time: [
                                {
                                    start_time: "12:00",
                                    start_time_type: 1,
                                    end_time: "13:00",
                                    end_time_type: 1,
                                },
                            ],
                            is_set_rset: 1,
                            work_per_day: 1,
                            work_hour: 8,
                        },
                    },
                    {
                        week: 6,
                        title: "周六",
                        data: {
                            day_type: "reset", //reset
                            work_time: {
                                start_time: "09:00",
                                start_time_type: 1,
                                end_time: "18:00",
                                end_time_type: 1,
                            },
                            rest_time: [
                                {
                                    start_time: "12:00",
                                    start_time_type: 1,
                                    end_time: "13:00",
                                    end_time_type: 1,
                                },
                            ],
                            is_set_rset: 1,
                            work_per_day: 1,
                            work_hour: 8,
                        },
                    },
                    {
                        week: 7,
                        title: "周日",
                        data: {
                            day_type: "reset", //reset
                            work_time: {
                                start_time: "09:00",
                                start_time_type: 1,
                                end_time: "18:00",
                                end_time_type: 1,
                            },
                            rest_time: [
                                {
                                    start_time: "12:00",
                                    start_time_type: 1,
                                    end_time: "13:00",
                                    end_time_type: 1,
                                },
                            ],
                            is_set_rset: 1,
                            work_per_day: 1,
                            work_hour: 8,
                        },
                    },
                ],
                is_use_public_holiday: 1,
            },
            attendanceFormRules: {
                attendance_group_name: [{ required: true, message: "请输入考勤组名称" }],
                use_user: [{ required: true, message: "请选择考勤人员", trigger: "change" }],
            },
            btnDisabled: false,
            // titles: "", // 选择考勤人员
            changeType: "", // 更改班次：changeItem，批量更改班次：changeBatch
            changeIndex: "",
            multipleSelection: [], // 表格复选框选中数据
            groupChangeDialogVisible: false, // 更改班次弹框
            groupChangeDialogTitle: "",
            attendanceData: [],

            userDepartmentVisible: false,
            disabledData:[],//禁用的人员
        };
    },
    created() {
        this.$nextTick(() => {
            this.$refs.attendanceForm && this.$refs.attendanceForm.resetFields("use_user");
        });
        if (this.editId) {
            this.getAttendanceGroupDetail();
        }else{
            this.getAttendanceGroupWithUser()
        }
    },
    methods: {
        // 获取详情
        getAttendanceGroupDetail() {
            this.groupTplLoading = true;
            GetAttendanceGroupDetail({ id: this.editId }).then((res) => {
                if (res.code === 200) {
                    let { attendance_group_name, attendance_rule, use_user, is_use_public_holiday,with_user} = res.data;
                    this.attendanceForm.attendance_group_name = attendance_group_name;
                    this.attendanceForm.use_user = use_user;
                    this.attendanceForm.attendance_rule = attendance_rule;
                    this.attendanceForm.is_use_public_holiday = Number(is_use_public_holiday);
                    this.attendanceForm.use_user_ids = use_user.map((item) => {
                        return item.relate_type_id;
                    });
                    this.disabledData = with_user
                    this.groupTplLoading = false;
                } else {
                    this.groupTplLoading = false;
                    this.$message.error(res.message);
                }
            });
        },
        // 新增考勤组时获取禁用的人员
        getAttendanceGroupWithUser(){
            this.groupTplLoading = true;
            GetAttendanceGroupWithUser().then((res) => {
                if (res.code === 200) {
                    let {with_user} = res.data;
                    this.disabledData = with_user
                }
                this.groupTplLoading = false;
            });
        },
        handleDialogClose() {
            this.$emit("update:groupTplDialogVisible", false);
        },
        // 清空
        handleClickClearPromoter() {
            this.attendanceForm.use_user = [];
            this.attendanceForm.use_user_ids = [];
        },
        // 点击人员的时候
        handleClickPromoter() {
            let promoterSelectedList = JSON.parse(JSON.stringify(this.attendanceForm.use_user));
            this.$refs.selectPromoter.blur();
            this.userDepartmentVisible = true;
        },
        // 选择部门人员回调
        userDepartmentSuccess(data) {
            this.attendanceForm.use_user = data;
            this.attendanceForm.use_user_ids = data.map((item) => {
                return item.relate_type_id;
            });
        },
        // 点击人员删除
        handleClickRemovePromoter(tag) {
            this.attendanceForm.use_user.forEach((item, index) => {
                if (item.relate_type_id == tag) {
                    this.attendanceForm.use_user.splice(index, 1);
                }
            });
        },
        // 批量更改班次 表格复选框选择数据
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 批量更改
        handleClickBatchChange() {
            if (this.multipleSelection.length == 0) {
                this.$message.error("请选择要更改的日期");
                return false;
            }
            this.changeType = "changeBatch";
            this.groupChangeDialogTitle = "批量更改班次";
            this.attendanceData = JSON.parse(JSON.stringify(this.multipleSelection[0].data));
            this.groupChangeDialogVisible = true;
        },
        // 更改班次
        handleClickEdit(row, index) {
            this.changeType = "changeItem";
            this.changeIndex = index;
            this.groupChangeDialogTitle = "更改班次";
            this.attendanceData = JSON.parse(JSON.stringify(row.data));
            this.groupChangeDialogVisible = true;
        },
        // 更改成功后获取的数据
        groupChangeSuccess(attendanceData) {
            if (this.changeType === "changeItem") {
                // 更改单个
                this.$set(
                    this.attendanceForm.attendance_rule[this.changeIndex],
                    "data",
                    JSON.parse(JSON.stringify(attendanceData))
                );
                this.attendanceData = null;
            } else {
                // 批量更改
                this.multipleSelection.forEach((item, index) => {
                    this.$set(item, "data", JSON.parse(JSON.stringify(attendanceData)));
                });
                this.multipleSelection = [];
                this.$refs.multipleTable.clearSelection();
            }
        },
        // 提交
        handleDialogConfirm() {
            this.$refs.attendanceForm.validate((valid) => {
                if (valid) {
                    let params = {
                        attendance_group_name: this.attendanceForm.attendance_group_name,
                        attendance_rule: this.attendanceForm.attendance_rule,
                        use_user: this.attendanceForm.use_user,
                        is_use_public_holiday: this.attendanceForm.is_use_public_holiday,
                    };
                    const h = this.$createElement;
                    this.$msgbox({
                        title: "保存考勤组",
                        message: h("div", null, [
                            h("span", null, `考勤组立即生效，今日考勤结果将按新规则计算，往期已生成的考勤结果不变！`),
                        ]),
                        iconClass: "icon-jinggao iconfont prompt_message_icon status1",
                        customClass: "prompt_message_custom attendance_message_custom",
                        confirmButtonText: "确定",
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        showCancelButton: true,
                        beforeClose: (action, instance, done) => {
                            if (action === "confirm") {
                                done();
                            } else {
                                done();
                            }
                        },
                    })
                        .then(() => {
                            this.btnDisabled = true;
                            this.groupTplLoading = true;
                            if (this.editId) {
                                // 编辑
                                params.id = this.editId;
                                UpdateAttendanceGroup(params)
                                    .then((res) => {
                                        if (res.code === 200) {
                                            this.btnDisabled = false;
                                            this.groupTplLoading = false;
                                            this.$message({
                                                message: res.message,
                                                type: "success",
                                                duration: 1000,
                                                onClose: () => {
                                                    this.handleDialogClose();
                                                    this.$emit("callbackSuccess");
                                                },
                                            });
                                        } else {
                                            this.btnDisabled = false;
                                            this.groupTplLoading = false;
                                            // this.$message.error(res.message);
                                        }
                                    })
                                    .catch(() => {
                                        this.btnDisabled = false;
                                        this.groupTplLoading = false;
                                    });
                            } else {
                                // 新增
                                AddAttendanceGroup(params)
                                    .then((res) => {
                                        if (res.code === 200) {
                                            this.btnDisabled = false;
                                            this.groupTplLoading = false;
                                            this.$message({
                                                message: res.message,
                                                type: "success",
                                                duration: 1000,
                                                onClose: () => {
                                                    this.handleDialogClose();
                                                    this.$emit("callbackSuccess");
                                                },
                                            });
                                        } else {
                                            this.btnDisabled = false;
                                            this.groupTplLoading = false;
                                            // this.$message.error(res.message);
                                        }
                                    })
                                    .catch(() => {
                                        this.btnDisabled = false;
                                        this.groupTplLoading = false;
                                    });
                            }
                        })
                        .catch(() => {});
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-attendance-dialog {
    .el-form {
        ::v-deep {
            .groupSetUpTop {
                display: flex;
                justify-content: space-between;

                & > span {
                    font-size: 14px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                }
            }

            .legal {
                width: 100%;
                height: 38px;
                border-radius: 4px;
                background: rgba(237, 240, 244, 1);
                padding: 8px 12px;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
        }
    }
}
</style>
<style lang="scss">
.el-message-box__wrapper {
    .attendance_message_custom {
        width: 390px;
    }
}
</style>
